import apiAxios from '../../services/axios/axiosConfig';
import { IAccount } from '@/types/account';

async function account() {
  const response = await apiAxios.get<IAccount>('/api/v1/account', {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
}

export default account;
